module.exports = __webpack_public_path__ + "static/img/banner1.f90bf76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner1.png
// module id = CMrX
// module chunks = 4